import React from "react";
import "./AppTable.css";

/// Tag chips for a table cell. Shows the first `max` tags on one line and
/// folds the rest into a "+N" chip whose tooltip lists every tag.
const TableTags = ({ tags, max = 2 }) => {
  const list = (tags ?? []).filter(Boolean);
  if (list.length === 0) return <span className="text-soft">-</span>;
  const shown = list.slice(0, max);
  const hidden = list.length - shown.length;

  return (
    <div className="app-table-tags" title={list.join(", ")}>
      {shown.map((tag) => (
        <span key={tag} className="app-table-tags__chip">
          {tag}
        </span>
      ))}
      {hidden > 0 && (
        <span className="app-table-tags__chip app-table-tags__chip--more">
          +{hidden}
        </span>
      )}
    </div>
  );
};

export default TableTags;
